export default {
  forgot_password_confirm: {
    title: 'Atur ulang kata sandi',
    required_code: 'Kode wajib diisi',
    required_password: 'Kata sandi harus diisi',
    max_length_16: 'Kata sandi harus terdiri dari 8-16 karakter',
    // no_blank: "",
    no_password_match: 'Kata sandi tidak cocok',
    reset_password: 'Atur Ulang Kata Sandi',
    caution: 'Jangan menutup jendela ini',
    double_check_text: '@:login.double_check_text',
    password_reset_text: 'Email telah dikirim ke alamat email. Masukkan kode verifikasi yang dikirim ke email Anda di bawah ini.',
    verification_code: 'Kode Verifikasi',
    mail_send_code: 'Kode dikirim melalui email',
    password: 'Kata sandi',
    new_password: 'Kata Sandi Baru',
    password_display: 'Tampilkan kata sandi',
    password_no_display: 'Sembunyikan kata sandi',
    password_check: 'Kata Sandi Baru (Konfirmasi)',
    submit: 'Konfirmasi',
  },
}
